"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SignatureBox_1 = require("./SignatureBox");
exports.SignatureBox = SignatureBox_1.SignatureBox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy90ZXN0L1NhbXBsZS9wYXJ0cy9TaWduYXR1cmVCb3gvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQ0FBMkM7QUFBbkMsc0NBQUEsWUFBWSxDQUFBIn0=